<template>
  <!-- 订单历史数据 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="公告类型">
          <a-select v-model="input.Type" style="width: 200px">
            <a-select-option value="0"> 全部</a-select-option>
            <a-select-option value="1"> 电子</a-select-option>
            <a-select-option value="2"> 真人</a-select-option>
            <a-select-option value="3"> 借呗</a-select-option>
            <a-select-option value="4"> 优惠活动大厅(跑马灯)</a-select-option>
            <a-select-option value="5"> 交易账号</a-select-option>
            <a-select-option value="6"> 翻本金(跑马灯)</a-select-option>
            <a-select-option value="7"> 电子竞技榜(跑马灯)</a-select-option>
            <a-select-option value="8"> USDT排行榜</a-select-option>
            <a-select-option value="9"> 会员VIP</a-select-option>
            <a-select-option value="10"> 自助客服</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model="input.State" style="width: 120px">
            <a-select-option value="0"> 全部</a-select-option>
            <a-select-option value="1"> 未发布</a-select-option>
            <a-select-option value="2"> 已发布</a-select-option>
            <a-select-option value="3"> 已结束</a-select-option>
            <a-select-option value="4"> 停用</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="关键字">
          <a-input v-model="input.Content" />
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker
            :default-value="[moment().startOf('week'), moment().endOf('week')]"
            show-time
            :format="dateFormat"
            :ranges="dataRange"
            @change="onChange" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="query()"><a-icon
              type="search" /></a-button>
        </a-form-item>
      </a-form>
    </div>
    <br />
    <a-table
      bordered
      size="small"
      row-key="ID"
      :row-selection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
      :loading="loading"
      :columns="columns"
      :data-source="datarow"
      :pagination="pagination"
      @change="changepage">
      <template slot="title">
        <a-row :gutter="24">
          <a-col style="float: right">
            <a-button type="primary" @click="showmodel()">新增公告</a-button>
          </a-col>
          <a-col style="float: left">
            <a href="javascript:;" @click="batchdelete()">
              <a-icon type="delete" style="font-size: 22px"></a-icon>
              <span style="font-size: 15px">批量删除</span>
            </a>
          </a-col>
        </a-row>
      </template>
<template slot="Type" slot-scope="text, record">
        <span v-if="record.Type == '1'">电子</span>
        <span v-if="record.Type == '2'">真人</span>
        <span v-if="record.Type == '3'">借呗</span>
        <span v-if="record.Type == '4'">优惠活动大厅(跑马灯)</span>
        <span v-if="record.Type == '5'">交易账号</span>
        <span v-if="record.Type == '6'">翻本金(跑马灯)</span>
        <span v-if="record.Type == '7'">电子竞技榜(跑马灯)</span>
        <span v-if="record.Type == '8'">USDT排行榜</span>
        <span v-if="record.Type == '9'">会员VIP</span>
        <span v-if="record.Type == '10'">自助客服</span>
      </template>
<template slot="State" slot-scope="text, record">
        <span v-if="record.State == '1'">未发布</span>
        <span v-if="record.State == '2'">已发布</span>
        <span v-if="record.State == '3'">已结束</span>
        <span v-if="record.State == '4'">停用</span>
      </template>
<template slot="Content" slot-scope="text, record">
        <span v-html="record.Content"></span>
      </template>
<template slot="publishTime" slot-scope="text, record">
        <span>{{
          transDateFormat(record.Sdt) + " ~ " + transDateFormat(record.Edt)
          }}
        </span>
      </template>
<template slot="Ldt" slot-scope="text, record">
        <span>{{ transDateFormat(record.Ldt) }}</span>
      </template>
<template slot="Operation" slot-scope="text, record">
        <a-tooltip title="编辑">
          <a @click="showmodel(record)">
            <a-icon type="edit" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
        &nbsp;&nbsp;
        <a-tooltip title="删除">
          <a @click="deleteMsg(record)">
            <a-icon type="delete" style="font-size: 22px"></a-icon>
          </a>
        </a-tooltip>
      </template>
</a-table>

<!--------------------------------------------------弹窗部份-------------------------------------------------->
<a-modal v-model="visible" title="新增/编辑公告" width="60%" ok-text="储存" cancel-text="取消" @ok="save" layout="inline">
    <a-form-model :model="edit" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="公告ID" v-if="edit.Mid != 0">
            <span>{{ edit.Mid }}</span>
        </a-form-model-item>
        <a-form-item label="公告类型">
            <a-select v-model="edit.Type" style="width: 200px">
                <a-select-option value="1"> 电子</a-select-option>
                <a-select-option value="2"> 真人</a-select-option>
                <a-select-option value="3"> 借呗</a-select-option>
                <a-select-option value="4"> 优惠活动大厅(跑马灯)</a-select-option>
                <a-select-option value="5"> 交易账号</a-select-option>
                <a-select-option value="6"> 翻本金(跑马灯)</a-select-option>
                <a-select-option value="7"> 电子竞技榜(跑马灯)</a-select-option>
                <a-select-option value="8"> USDT排行榜</a-select-option>
                <a-select-option value="9"> 会员VIP</a-select-option>
                <a-select-option value="10"> 自助客服</a-select-option>
                <a-select-option value="11"> 代理活动</a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item label="状态">
            <a-select v-model="edit.State" style="width: 120px">
                <a-select-option value="1"> 未发布</a-select-option>
                <a-select-option value="2"> 已发布</a-select-option>
                <a-select-option value="3"> 已结束</a-select-option>
                <a-select-option value="4"> 停用</a-select-option>
            </a-select>
        </a-form-item>
        <a-form-item label="排序">
            <a-input-number v-model="edit.Sort" />
        </a-form-item>
        <a-form-item label="时间范围">
            <a-range-picker :value="dateValue" :format="dateFormat" :ranges="dataRange" @change="modelonChange" />
        </a-form-item>
        <a-form-item label="公告内容">
            <editor v-model="edit.Content" :type="2" :barSet="1" barClass="toolbar3" style="width: 100%;"></editor>
        </a-form-item>
    </a-form-model>
</a-modal>
<!--------------------------------------------------弹窗部份-------------------------------------------------->
</a-layout-content>
</template>
<script>
    import moment from "moment";
    import VueTrix from "vue-trix";
    import editor from "../../components/tools/wangEditor";

    export default {
        data() {
            return {
                dateValue: null,
                dataRange,
                dateFormat: "YYYY-MM-DD HH:mm:ss",
                datarow: [],
                columns: IninTable(),
                action: "",
                pagination: {
                    total: 0,
                    pageindex: 1,
                    pagesize: 10,
                    showTotal: (total) => `共 ${total} 条`,
                    showSizeChanger: true, // 可以改变每页个数
                    pageSizeOptions: ["10", "20", "30", "40", "50"],
                    onShowSizeChange: (current, pageSize) => (this.pageSize = pageSize),
                },
                loading: false,
                visible: false,
                input: {
                    Type: "0",
                    State: "0",
                    Content: " ",
                    Sdt: "",
                    Edt: "",
                },
                edit: {
                    Mid: "0",
                    Type: "0",
                    State: "0",
                    Sdt: "",
                    Edt: "",
                    Sort: "0",
                    Content: "",
                },
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 14
                },
                selectedRowKeys: [],
            };
        },
        components: {
            VueTrix,
            editor
        },
        methods: {
            moment,
            //翻页
            changepage(e) {
                this.pagination.pageindex = e.current;
                this.pagination.pagesize = e.pageSize;
                this.query();
            },
            // 查询时间绑定
            onChange(value, dateString) {
                console.log(dateString);
                this.input.Sdt = dateString[0];
                this.input.Edt = dateString[1];
            },
            // 新增/编辑时间绑定
            modelonChange(value, dateString) {
                console.log(dateString);

                this.dateValue = null;
                this.edit.Sdt = dateString[0];
                this.edit.Edt = dateString[1];
                this.dateValue = [
                    this.getDateCn(dateString[0], "yyyy-MM-dd HH:mm:ss"),
                    this.getDateCn(dateString[1], "yyyy-MM-dd HH:mm:ss"),
                ];
            },
            //批量选取
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
            transDateFormat(val) {
                let time = this.getDateCn(val, "yyyy-MM-dd HH:mm:ss");

                return time;
            },
            modeltime(sdt, edt) {
                if (this.action == "Add") {
                    this.dateValue = [moment().startOf("week"), moment().endOf("week")];
                } else {
                    sdt = this.getDateCn(sdt, "yyyy-MM-dd HH:mm:ss");
                    edt = this.getDateCn(edt, "yyyy-MM-dd HH:mm:ss");
                    this.dateValue = [sdt, edt];
                }
            },
            showmodel(record) {
                this.visible = true;
                if (stringIsNullorEmpty(record)) {
                    this.action = "Add";
                    this.edit.Mid = 0;
                    this.edit.Type = "1";
                    this.edit.State = "1";
                    this.edit.Sort = "0";
                    this.edit.Content = "";

                    this.modeltime();
                } else {
                    this.action = "Edit";
                    let params = {
                        Mid: record.ID,
                    };
                    this.axios.post("/message/getmessagebyid", params).then((res) => {
                        if (res.data) {
                            this.edit.Mid = record.ID;
                            this.edit.Type = res.data[0].Type.toString();
                            this.edit.State = res.data[0].State.toString();
                            this.edit.Sort = res.data[0].Sort.toString();
                            this.edit.Sdt = res.data[0].Sdt;
                            this.edit.Edt = res.data[0].Edt;
                            this.edit.Content = res.data[0].Content;

                            this.modeltime(res.data[0].Sdt, res.data[0].Edt);
                        }
                    });
                }
            },
            query() {
                if (this.input.Sdt === "") {
                    this.$message.warning("请选择查询开始时间!");
                    return false;
                }
                if (this.input.Edt === "") {
                    this.$message.warning("请选择查询结束时间!");
                    return false;
                }

                let params = {
                    Type: this.input.Type,
                    State: this.input.State,
                    Content: this.input.Content,
                    Sdt: this.input.Sdt,
                    Edt: this.input.Edt,
                    pageindex: this.pagination.pageindex,
                    pagesize: this.pagination.pagesize,
                };
                this.axios.post("/message/getmessagelist", params).then((res) => {
                    this.datarow = res.data;
                    this.pagination.total = res.total;
                });
            },
            save() {
                if (this.edit.Sdt === "") {
                    this.$message.warning("开始发布时间不为空!");
                    return false;
                }
                if (this.edit.Edt === "") {
                    this.$message.warning("结束发布时间不为空!");
                    return false;
                }

                let params = {
                    Mid: this.edit.Mid,
                    Type: this.edit.Type,
                    State: this.edit.State,
                    Sort: this.edit.Sort,
                    Sdt: this.edit.Sdt,
                    Edt: this.edit.Edt,
                    Content: this.edit.Content,
                };

                let url = "";
                let msg = "";

                if (this.action == "Add") {
                    url = "/message/addmessage";
                    msg = "新增成功";
                } else if (this.action == "Edit") {
                    url = "/message/editmessage";
                    msg = "编辑成功";
                }

                this.axios.post(url, params).then((res) => {
                    if (res.data) {
                        this.$message.success(msg);
                        this.query();
                        this.visible = false;
                    }
                });
            },
            deleteMsg(record) {
                const that = this;
                this.$confirm({
                    title: "批量删除",
                    content: "您要确定要删除勾选数据吗?",
                    onOk() {
                        let params = {
                            Mid: record.ID,
                        };

                        that.axios.post("/message/deletemessage", params).then((res) => {
                            if (res.data) {
                                that.$message.success("删除成功");
                                that.query();
                            }
                        });
                    },
                });
            },
            batchdelete() {
                if (this.selectedRowKeys.length < 1) {
                    this.$message.warning("请勾选数据");
                    return;
                }
                const that = this;
                this.$confirm({
                    title: "批量删除",
                    content: "您要确定要删除勾选数据吗?",
                    onOk() {
                        const IDList = [];
                        that.selectedRowKeys.forEach((element) => {
                            IDList.push({
                                ID: element
                            });
                        });
                        that.axios
                            .post("/message/batchdeletemessage", {
                                IDList: IDList,
                            })
                            .then((res) => {
                                if (res.data) {
                                    that.$message.success("删除成功");
                                    that.query();
                                }
                            });
                    },
                });
            },
        },
        watch: {
            $route(to, from) {
                if (this.$route.params.name === "message") {
                    this.query();
                }
            },
        },
        //首次加载
        created() {
            // 初始化时间
            this.input.Sdt = moment().startOf("year").format(this.dateFormat);
            this.input.Edt = moment().endOf("year").format(this.dateFormat);
            this.edit.Sdt = moment().startOf("year").format(this.dateFormat);
            this.edit.Edt = moment().endOf("year").format(this.dateFormat);
            this.query();
        },
    };

    let dataRange = {
        今天: [moment().startOf("day"), moment().endOf("day")],
        昨天: [
            moment().startOf("day").subtract(1, "days"),
            moment().endOf("day").subtract(1, "days"),
        ],
        本周: [moment().startOf("week"), moment().endOf("week")],
        最近一周: [moment().startOf("day").subtract(1, "weeks"), moment()],
        最近两周: [moment().startOf("day").subtract(2, "weeks"), moment()],
        本月: [moment().startOf("month"), moment().endOf("month")],
        最近1个月: [moment().startOf("day").subtract(1, "months"), moment()],
        最近3个月: [moment().startOf("day").subtract(3, "months"), moment()],
        最近半年: [moment().startOf("day").subtract(6, "months"), moment()],
        今年: [moment().startOf("years"), moment().endOf("years")],
        最近1年: [moment().startOf("day").subtract(1, "years"), moment()],
        去年: [
            moment().startOf("years").subtract(1, "years"),
            moment().endOf("years").subtract(1, "years"),
        ],
    };

    const IninTable = function IninTable() {
        var header = [];

        header.push({
            title: "ID",
            align: "center",
            width: 50,
            dataIndex: "ID"
        });
        header.push({
            title: "公告类型",
            align: "center",
            scopedSlots: {
                customRender: "Type"
            },
        });
        header.push({
            title: "状态",
            align: "center",
            scopedSlots: {
                customRender: "State"
            },
        });
        header.push({
            title: "内容",
            align: "center",
            scopedSlots: {
                customRender: "Content"
            },
            width: 600,
        });
        header.push({
            title: "发布时间",
            align: "center",
            scopedSlots: {
                customRender: "publishTime"
            },
            width: 300,
        });
        header.push({
            title: "排序",
            align: "center",
            dataIndex: "Sort"
        });
        header.push({
            title: "修改时间",
            align: "center",
            scopedSlots: {
                customRender: "Ldt"
            },
        });
        header.push({
            title: "修改人",
            align: "center",
            dataIndex: "Editor",
        });
        header.push({
            title: "操作",
            align: "center",
            scopedSlots: {
                customRender: "Operation"
            },
            width: 100,
        });

        return header;
    };

    function stringIsNullorEmpty(value) {
        return !value || value == undefined || value == "" || value.length == 0;
    }
</script>

<style>
    #editor1 {
        height: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/components/receptionset/message.vue